<div class="dialog-viewer">
    <h2 mat-dialog-title>Edit Booking - {{confirmationNumber}}</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Simulator</mat-label>
                            <mat-select required formControlName="simulatorId" matInput name="simulatorId" id="simulatorId"
                                placeholder="Select Simulator" (selectionChange)="getTimeSlots()">
                                <mat-option *ngFor="let simulator of simulators" [value]="simulator.id">{{simulator.bayNumber}} ({{simulator.bayName}})</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('simulatorId').errors?.required">Simulator is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Date</mat-label>
                            <mat-select required [formControl]="dateControl" placeholder="Select Date" (selectionChange)="getTimeSlots()">
                                <mat-option *ngFor="let date of availableDates" [value]="date">
                                    {{ date | date:'MM/dd/YYYY' }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="dateControl.errors?.required">Date is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Duration</mat-label>
                            <mat-select required formControlName="duration" matInput name="duration" id="duration"
                                placeholder="Select Duration" (selectionChange)="getTimeSlots()">
                                <mat-option *ngFor="let duration of availableBookingDurations" [value]="duration.durationMinutes">
                                    {{formatDuration(duration.durationMinutes)}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('duration').errors?.required">Duration is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Time Slot</mat-label>
                            <mat-select required [formControl]="timeSlot" matInput name="timeSlot" id="timeSlot"
                                placeholder="Select Time Slot" [disabled]="availableTimeSlots.length == 0" 
                                (selectionChange)="setEndTimeAndTotalPrice($event.value)">
                                <mat-option *ngFor="let timeslot of availableTimeSlots" [value]="timeslot">
                                    {{timeslot.startTime | date: 'h:mm a'}} - {{timeslot.endTime | date: 'h:mm a'}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="timeSlot.errors?.required">Time Slot is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Status</mat-label>
                            <mat-select required formControlName="status" matInput name="status" id="status"
                                placeholder="Status">
                                <mat-option *ngFor="let status of bookingStatusEnumKeys"
                                    [value]="bookingStatusEnum[status]">
                                    <ng-container
                                        *ngIf="status === bookingStatusEnum[3]">Closed/Maintenance</ng-container>
                                    <ng-container *ngIf="status !== bookingStatusEnum[3]">{{ status }}</ng-container>
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('status').errors?.required">Status is required
                            </mat-error>
                            <mat-error *ngIf="form.get('status').errors?.validationErrors">
                                {{ form.get("status").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Number of Golfers</mat-label>
                            <input matInput name="participants" id="participants" placeholder="Number of Golfers"
                                type="number" min="1" max="6" formControlName="participants" />
                            <mat-error *ngIf="form.get('participants').errors?.required">Number of Golfers is required
                            </mat-error>
                            <mat-error *ngIf="form.get('participants').errors?.validationErrors">
                                {{ form.get("participants").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row align-items-baseline">
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Customer Name</mat-label>
                            <input required matInput name="customerName" id="customerName" placeholder="Customer Name"
                                type="text" formControlName="customerName" />
                            <mat-error *ngIf="form.get('customerName').errors?.required">Customer Name is required
                            </mat-error>
                            <mat-error *ngIf="form.get('customerName').errors?.validationErrors">
                                {{ form.get("customerName").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Email</mat-label>
                            <input matInput name="email" id="email" placeholder="Email" type="email"
                                formControlName="email" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Phone Number</mat-label>
                            <input matInput name="phoneNumber" id="phoneNumber" placeholder="Phone Number"
                                type="tel" formControlName="phoneNumber"/>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row align-items-baseline">
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Addons</mat-label>
                            <mat-select multiple formControlName="addons" (selectionChange)="onAddonSelectionChange($event)">
                                <mat-option *ngFor="let addon of availableAddons" [value]="addon">
                                    {{addon.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row align-items-baseline" *ngIf="form.get('status').value !== 4">
                    <div class="col-4">
                        <mat-checkbox #priceOverride [disabled]="availableTimeSlots.length == 0">Price Override</mat-checkbox>
                    </div>
                    <ng-container *ngIf="priceOverride.checked">
                        <div class="col-4">
                            <mat-form-field>
                                <span matPrefix>$ &nbsp;</span>
                                <mat-label>Price Override</mat-label>
                                <input matInput name="priceOverride" id="priceOverride" placeholder="Price Override"
                                    type="number" min="0" formControlName="priceOverride" />
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field>
                                <mat-label>Price Override Reason</mat-label>
                                <input matInput name="priceOverrideReason" id="priceOverrideReason"
                                    placeholder="Price Override Reason" type="text"
                                    formControlName="priceOverrideReason" />
                            </mat-form-field>
                        </div>
                    </ng-container>
                </div>
                <hr />
                <div class="row mt-2" *ngIf="form.get('status').value !== 4">
                    <h3 class="col">Total: ${{form.get('totalPrice').value | number:'1.2-2'}}</h3>
                </div>
            </div>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading || !form.valid">Save</button>
                <button mat-raised-button class="warning" (click)="$event.preventDefault; dialogRef.close('cancel')" color="warn" type="button"
                    [disabled]="isLoading">Cancel</button>
            </div>
        </mat-dialog-actions>
    </form>
</div>